import type { StudentSearchResultResource } from "api/generated";
import type { StudentSearchResult } from "shared/types";

export const studentSearchResultFromDto = (
  resource: StudentSearchResultResource,
): StudentSearchResult => ({
  id: resource.id,
  name: resource.name,
  avatar: resource.avatar ?? null,
  studentNumber: resource.student_number ?? null,
  mentorClass: resource.mentor_class,
});
